import { Component, OnInit, SimpleChanges, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';

@Component({
  selector: 'app-view-availabilities',
  templateUrl: './view-availabilities.component.html',
  styleUrls: ['./view-availabilities.component.scss']
})
export class ViewAvailabilitiesComponent implements OnInit {

  inputData: any;
  studentAvailabilities: any;
  professorName: string;
  color: string;

  constructor(@Inject(MAT_DIALOG_DATA) data,
    public dialogRef: MatDialogRef<ViewAvailabilitiesComponent>
  ) {
    this.inputData = data;
    this.studentAvailabilities = this.inputData.disponibilitaRichiedente;
    if (this.inputData.professor) {
      this.professorName = this.inputData.professor.surname + ' ' + this.inputData.professor.name;
    }
    if (!this.inputData.color) {
      this.color = this.inputData.color;
    } else {
      this.color = '#3c4252';
    }
  }

  // tslint:disable-next-line:use-life-cycle-interface
  ngOnChanges(changes: SimpleChanges): void {
  }

  async ngOnInit() {
  }

  onButtonClick(item) {
    if (!item) {
      return;
    }
    let value = null;
    if (item.value) {
      value = item.value;
    }
    if (item.callback) {
      item.callback(value);
    }
    if (item.close) {
      this.dialogRef.close(value);
    }
  }

}
